@if (!standaloneItems?.length) {
  @if (isModal) {
    <app-empty-state
      imageSrc="/assets/cart-empty.svg"
      titleResource="components.cart-content.empty-cart-title"
      descriptionResource="components.cart-content.empty-cart-description"
    />
  } @else {
    <app-location-schedule />
  }
} @else {
  @if (appointment.date) {
    <div class="mb-5 flex items-center">
      <div class="text-xl leading-3 text-neutral-600">
        <span nz-icon nzType="calendar" nzTheme="outline" class="me-2"></span>
      </div>
      <h3 nz-typography>
        {{ appointment.date | dateFormat: location.dateFormat : location.timeZone }}
        {{ appointment.date | timeFormat: location.timeFormat : location.timeZone }}
      </h3>
    </div>
  }
  <app-appointment-summary
    [appointment]="appointment"
    [location]="location"
    [clickableItems]="!isReschedule && !selfCheckout"
    [showDeleteActions]="!isReschedule && !selfCheckout"
    [showRemainingAmount]="selfCheckout"
    (itemSelected)="onOpenItemDetails($event)"
    (itemDeleteRequested)="onDeleteItem($event)"
  ></app-appointment-summary>

  @if (showContinueButton) {
    <div class="mt-6 lg:block" [ngClass]="isModal ? 'block' : 'hidden'">
      <button
        nzBlock
        nz-button
        nzType="primary"
        nzSize="large"
        (click)="onContinue()"
        [disabled]="themeService.getCartBtnDisabled() | async"
      >
        {{ continueBtnLabel }}
      </button>
    </div>

    @if (themeService.getCartBtnInfoText() | async) {
      <div class="mt-4 text-center text-sm hidden lg:block">
        <app-appointment-status-info
          [type]="themeService.getCartBtnInfoType() | async"
          [text]="themeService.getCartBtnInfoText() | async"
        ></app-appointment-status-info>
      </div>
    }
  }
  @if (error) {
    <p nz-typography nzType="danger" class="text-center mt-2">{{ error }}</p>
  }
}
